import { SparkVisual, SparkVisualCopy } from '../BuyTokensModal.styles';
import { HERO_IMAGE } from '../constants/buyTokensModal.constants';

const BuyTokensModalHero = ({ heroTitle, heroDescription, fallbackTitle, fallbackDescription }) => (
	<SparkVisual aria-label={heroTitle || fallbackTitle}>
		<img src={HERO_IMAGE} alt="" aria-hidden="true" />
		<SparkVisualCopy>
			<h2>{heroTitle || fallbackTitle}</h2>
			<p>{heroDescription || fallbackDescription}</p>
		</SparkVisualCopy>
	</SparkVisual>
);

export default BuyTokensModalHero;
